import Vue from "vue";
import Router from "vue-router";

// 一级路由
const Home = () => import(/* webpackChunkName: "home" */ "./views/Home.vue");
const MemberCenter = () => import(/* webpackChunkName: "member" */ "./views/MemberCenter.vue");
const DynamicNews = () => import(/* webpackChunkName: "news" */ "./views/dynamicnews/DynamicNews.vue");
const SelfAssessment = () => import(/* webpackChunkName: "selfassessment" */ "./views/selfassessment/SelfAssessment.vue");
const SelfAssessmentEnter = () => import(/* webpackChunkName: "selfassessment" */ "./views/selfassessment/SelfAssessmentEnter.vue");
const AiAssessmentEnter = () => import(/* webpackChunkName: "selfassessment" */ "./views/selfassessment/AiAssessmentEnter.vue");
const AiAssessment = () => import(/* webpackChunkName: "selfassessment" */ "./views/selfassessment/AIAssessment.vue");
const MaterialAssessment = () => import(/* webpackChunkName: "materialassessment" */ "./views/selfassessment/MaterialAssessment.vue");
const EnergyAssessment = () => import(/* webpackChunkName: "energyassessment" */ "./views/selfassessment/EnergyAssessment.vue");
const SoftwareAssessment = () => import(/* webpackChunkName: "softwareassessment" */ "./views/selfassessment/SoftwareAssessment.vue");
const IntegratedCircuitAssessment = () => import(/* webpackChunkName: "integratedcircuitassessment" */ "./views/selfassessment/IntegratedCircuitAssessment.vue");
const EmergencyAssessment = () => import(/* webpackChunkName: "emergencyassessment" */ "./views/selfassessment/EmergencyAssessment.vue");
const SelfEvaluate = () => import(/* webpackChunkName: "selfassessment" */ "./views/selfassessment/SelfEvaluate.vue");
const IndustryMap = () => import(/* webpackChunkName: "map" */ "./views/IndustryMap.vue");
const AboutUS = () => import(/* webpackChunkName: "about" */ "./views/AboutUS.vue");
const Login = () => import(/* webpackChunkName: "login" */ "./views/Login.vue");
const Register = () => import(/* webpackChunkName: "register" */ "./views/Register.vue");
const test = () => import(/* webpackChunkName: "test" */ "./views/test.vue");
const HuiyuanCenter = () => import(/* webpackChunkName: "member" */ "./views/HuiyuanCenter.vue");

// 二级路由
const Notice = () => import(/* webpackChunkName: "news" */ "./views/dynamicnews/Notice.vue");
const News = () => import(/* webpackChunkName: "news" */ "./views/dynamicnews/News.vue");
const Article = () => import(/* webpackChunkName: "article" */ "./views/Article.vue");
const ArticleList = () => import(/* webpackChunkName: "article" */ "./views/ArticleList.vue");

Vue.use(Router);

const router = new Router({
  //linkActiveClass: "active",
  linkActiveClass: "active",
  routes: [
    {
      path: "/test",
      name: "test",
      component: test
    },
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/membercenter",
      name: "membercenter",
      component: MemberCenter
    },
    {
      path: "/articlelist",
      name: "articlelist",
      component: ArticleList
    },
    {
      path: "/article/:id",
      name: "article",
      component: Article
    },
    {
      path: "/dynamicnews",
      name: "dynamicnews",
      component: DynamicNews,
      children: [
        {
          path: "",
          redirect: "/notice"
        },
        {
          path: "/notice",
          name: "notice",
          component: Notice
        },
        {
          path: "/news",
          name: "news",
          component: News
        }
      ]
    },
    {
      path: "/selfassessment",
      name: "selfassessment",
      component: SelfAssessment
    },
    {
      path: "/selfassessmententer",
      name: "selfassessmententer",
      component: SelfAssessmentEnter
    },
    {
      path: "/aiassessmententer",
      name: "aiassessmententer",
      component: AiAssessmentEnter
    },
      {
        path: "/aiassessment",
        name: "aiassessment",
        component: AiAssessment
      },
      {
        path: "/materialassessment",
        name: "materialassessment",
        component: MaterialAssessment
      },
      {
        path: "/energyassessment",
        name: "energyassessment",
        component: EnergyAssessment
      },
      {
        path: "/softwareassessment",
        name: "softwareassessment",
        component: SoftwareAssessment
      },
      {
        path: "/integratedcircuitassessment",
        name: "integratedcircuitassessment",
        component: IntegratedCircuitAssessment
      },
      {
        path: "/emergencyassessment",
        name: "emergencyassessment",
        component: EmergencyAssessment
      },
    {
      path: "/selfevaluate",
      name: "selfevaluate",
      component: SelfEvaluate
    },
    {
      path: "/industrymap",
      name: "industrymap",
      component: IndustryMap
    },
    {
      path: "/aboutus",
      name: "aboutus",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: AboutUS
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/register",
      name: "register",
      component: Register
    },
    {
      path: "/huiyuanCenter",
      name: "huiyuanCenter",
      component: HuiyuanCenter
    },
  ]
});

const siteName = "北京企业技术中心创新服务联盟";
const titles = {
  home: siteName,
  membercenter: "会员中心",
  articlelist: "动态要闻",
  article: "文章详情",
  dynamicnews: "动态要闻",
  notice: "通知公告",
  news: "产业要闻",
  selfassessment: "企业自评",
  selfassessmententer: "基础评价",
  selfevaluate: "企业自评",
  materialassessment: "先进材料企业创新能级评估",
  energyassessment: "绿色先进能源与低碳环保企业创新能级评估",
  softwareassessment: "信息软件企业创新能级评估",
  integratedcircuitassessment: "集成电路企业创新能级评估",
  emergencyassessment: "新型安全应急装备企业创新能级评估",
  industrymap: "产业地图",
  aboutus: "关于我们",
  login: "会员登录",
  register: "会员注册",
  huiyuanCenter: "会员中心",
  test: "测试"
};

router.afterEach(to => {
  const pageTitle = titles[to.name];
  document.title = !pageTitle || pageTitle === siteName
    ? siteName
    : `${pageTitle} - ${siteName}`;
});

export default router;
